"use strict";const r=require("./index14.js"),o=require("./index288.js");var e=r._export,t=o.dateToIsoString;e({target:"Date",proto:!0,forced:Date.prototype.toISOString!==t},{toISOString:t});
